/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki } from './FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki';
import {
    instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSON,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped,
    FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON,
} from './FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki';

/**
 * @type FxGamesLibWebPlatformDataOptionsOdnoklassniki
 * 
 * @export
 */
export type FxGamesLibWebPlatformDataOptionsOdnoklassniki = FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki;

export function FxGamesLibWebPlatformDataOptionsOdnoklassnikiFromJSON(json: any): FxGamesLibWebPlatformDataOptionsOdnoklassniki {
    return FxGamesLibWebPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsOdnoklassnikiFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsOdnoklassniki {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki(json)) {
        return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPlatformDataOptionsOdnoklassnikiToJSON(json: any): any {
    return FxGamesLibWebPlatformDataOptionsOdnoklassnikiToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsOdnoklassnikiToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsOdnoklassniki | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki(value)) {
        return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON(value as FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki);
    }

    return {};
}

